import type React from "react";
import { Component, type ReactNode } from "react";
import { toAbsoluteUrl } from "../../helpers";

interface ErrorBoundaryProps {
	children: ReactNode;
	fallback?: ReactNode;
	onError?: (error: Error, info: React.ErrorInfo) => void;
}

interface ErrorBoundaryState {
	hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
	state: ErrorBoundaryState = { hasError: false };

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error: Error, info: React.ErrorInfo) {
		console.error("ErrorBoundary caught:", error, info);
		this.props.onError?.(error, info);
	}

	//   componentDidMount() {
	//     document.body.style.backgroundImage = `url(${toAbsoluteUrl(
	//       "media/auth/bg8.jpg"
	//     )})`;
	//     document.body.style.backgroundSize = "cover";
	//     document.body.style.backgroundRepeat = "no-repeat";
	//     document.body.style.backgroundPosition = "center";
	//   }

	componentWillUnmount() {
		document.body.style.backgroundImage = "";
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className="d-flex flex-column flex-root min-vh-100">
					<div className="d-flex flex-column flex-center flex-column-fluid">
						<div className="d-flex flex-column flex-center text-center p-10">
							<div className="card-body py-15 py-lg-20">
								<div className="p-8 bg-white rounded-2xl shadow-lg max-w-md mx-auto text-center border border-red-200 ">
									{/* Error Illustration */}
									<div className="mb-5">
										<img
											src={toAbsoluteUrl("media/images/error.png")}
											className="mw-100 mh-80px theme-light-show"
											alt="error"
										/>
										<img
											src={toAbsoluteUrl("media/auth/404-error-dark.png")}
											className="mw-100 mh-300px theme-dark-show"
											alt="error-dark"
										/>
									</div>

									{/* Title */}
									<h2 className="font-bold text-2xl text-gray-800">
										Something went wrong
									</h2>

									{/* Description */}
									<p className="mt-3 text-gray-600">
										Please try refreshing the page. If the problem persists,
										contact support.
									</p>

									{/* Actions */}
									<div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
										<button
											onClick={() => window.location.reload()}
											className="btn btn-info px-5 m-2 py-2 fw-semibold shadow"
										>
											Refresh Page
										</button>
										<a
											href="/"
											className="btn btn-secondary px-5 py-2 fw-semibold shadow"
										>
											Go Home
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			);
		}
		return this.props.children;
	}
}

export default ErrorBoundary;
